export default __webpack_public_path__ + "static/media/wallet.072baaff.svg";